import UserAvatar from '../UserAvatar/UserAvatar';
import UserRelationButton from '../UserRelationButton/UserRelationButton';
import { get } from '../../Services/NetteApiClient';

export default function SearchWorkplaceDoctorResult(props) {
	const { workplaceMember, handleClick = null } = props;
	const { user, workplace } = workplaceMember;

	// @ts-ignore
	const onClick = async workplaceMember => {
		handleClick(workplaceMember);
	};

	return (
		<a
			onClick={() => onClick(workplaceMember)}
			className='search-user-result__item d-flex'
		>
			<div className='search-user-result__item-image-wrapper'>
				<UserAvatar
					userId={user.id}
					customClass={'profile-photo profile-photo__searchUserResult'}
					type={'background'}
				/>
			</div>
			<div className='search-user-result__item__name'>
				{user.profile?.fullName}
			</div>
		</a>
	);
}
